import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Turno from './turno'

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  panel: {
    marginTop: theme.spacing.unit * 2,
  }
});

const Turnos = ({ classes, calendarioPedidos, value, fecha, setOpened, opened }) => {

    const handleChange = panel => (event, expanded) => {
        setOpened(expanded ? panel : false);
    };

    return (
      <div className={classes.root}>
        {calendarioPedidos ? calendarioPedidos.calendarios.map((data, index) => (
            <Turno key={index} {...{handleChange, expanded: opened, data, value: index, tipo: value, fecha}} />
        )) : null}
      </div>
    );
  }

  Turnos.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Turnos)